/**
 * Commerce7 Collection Filter - clear filter handle
 */

export default function C7Collection() {
	const selectors = {
		collectionWrapper: ".collection-wrapper",
		productList: ".c7-product-collection__product-list",
		product: ".product",
	};

	this.init = () => {
		c7.addAction("c7_collection_products_rendered", (collection) => {
			// Do something after collection rendered.

			// const products = jQuery(selectors.product);

			// products.each((index) => {

			// })

			// jQuery(selectors.collectionWrapper).removeClass("inner");

		});
	};
}
